<template>
  <div class="dropdown" :class="{'open': isOpen }" style="padding: 0">
    <input
      ref="input"
      type="text"
      class="field dropdown-input"
      @click="toggleDropdown"
      @input="$emit('update:modelValue', $event.target.value)"
      @change="$emit('update:modelValue', $event.target.value)"
      @keydown.enter.tab.esc="isOpen=false"
      :placeholder="placeholder"
      :value="modelValue"
      :class="class2"
    />
    <ul class="dropdown-menu" v-if="isOpen">
      <li
        v-for="(option, index) in options"
        :key="index"
        @click="selectOption(option)"
        class="dropdown-item"
      >
        {{ option[displayField] }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    class2: {},
    modelValue: {},
    options: {
      type: Array,
      required: true,
      default: () => [],
    },

    displayField: {
      type: String,
      default: 'name', // Поле, отображаемое в dropdown
    },
    valueField: {
      type: String,
      default: 'id', // Поле, используемое для значения выбранного элемента
    },
    placeholder: {
      type: String,
      default: 'Выберите опцию',
    },
  },
  data() {
    return {
      isOpen: false,
      selectedOption: null,
    };
  },

  methods: {
    toggleDropdown() {
      this.isOpen = !this.isOpen;
    },
    selectOption(option) {
      this.isOpen = false;
      this.$emit('update:modelValue', option[this.valueField]); // Эмитим событие input с выбранным value
    },
    handleClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.isOpen = false;
      }
    },
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  },
};
</script>

<style scoped>
.dropdown {
  position: relative;
}

.dropdown-input {
  margin: 0;
  border:none;
  width: 100%;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: -1px;
  width: 100%;
  z-index: 1000;
  display: none;

  padding: 0;
  margin: 0;
  font-size: 14px;

  list-style: none;
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.15);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);

}

.dropdown.open .dropdown-menu {
  display: block;
}

.dropdown-item {
  display: block;
  padding: 2px 5px;
  clear: both;
  font-weight: normal;
  line-height: 1.42857143;
  color: #333;
  white-space: nowrap;
  cursor: pointer;
}

.dropdown-item:hover {
  color: #262626;
  text-decoration: none;
  background-color: #f5f5f5;
}
</style>
